import React from 'react';
import DeleteCartItem from '../DeleteCartItem.component';
import PropTypes from 'prop-types';
import {
  EachCartItemContainer,
  CartItemContent,
  CourseName,
  PriceValue,
  DeleteCartButtonStyled,
  CartItemTopRow,
  CartItemDetails,
  Part2Inline,
} from './EachCartItem.styles';

const EachCartItem = ({ course, userId, item }) => {
  const cartItem = item || course || {};
  // Product support removed — all items are courses.
  // const isProduct = cartItem.itemType === 'product';
  // const linkHref = isProduct
  //   ? `/product/${cartItem?.productId}`
  //   : `/course/${cartItem?.courseId}`;
  const linkHref = `/course/${cartItem?.courseName}/${cartItem?.courseId}`;
  // const title = isProduct
  //   ? cartItem?.name || cartItem?.productName
  //   : cartItem?.courseName;
  const title = cartItem?.courseName;
  const price = cartItem?.price ?? 0;
  const quantity = cartItem?.quantity ?? 1;

  return (
    <EachCartItemContainer>
      <CartItemContent>
        <CartItemTopRow>
          <a href={linkHref} rel="noopener noreferrer">
            <CourseName>{title}</CourseName>
          </a>

          <PriceValue>${price}</PriceValue>
        </CartItemTopRow>

        <CartItemDetails>
          <span>Qty {quantity}</span>

          <span>
            {cartItem.expiryDate === 0
              ? 'No expiration'
              : `Certificate valid for ${cartItem?.expiryDate} ${
                  cartItem?.expiryDate === 1 ? 'year' : 'years'
                }`}
          </span>
        </CartItemDetails>

        {cartItem?.part2Price > 0 && (
          <Part2Inline>
            Part 2 onsite training is paid separately when booked:{' '}
            <strong>${cartItem.part2Price}</strong>
          </Part2Inline>
        )}
      </CartItemContent>

      <DeleteCartButtonStyled>
        <DeleteCartItem
          courseId={cartItem?.courseId || cartItem?.id || cartItem?._id}
          userId={userId}
          itemType="course"
        />
      </DeleteCartButtonStyled>
    </EachCartItemContainer>
  );
};

EachCartItem.propTypes = {
  course: PropTypes.shape({
    courseId: PropTypes.string,
    // _id: PropTypes.string,
    courseName: PropTypes.string,
    price: PropTypes.number,
    expiryDate: PropTypes.number,
    // productId: PropTypes.string,
    // itemType: PropTypes.string,
    part2Price: PropTypes.number,
  }),
  userId: PropTypes.string,
  id: PropTypes.string,
  productId: PropTypes.string,
  itemType: PropTypes.string,
  item: PropTypes.shape({
    courseId: PropTypes.string,
    courseName: PropTypes.string,
    price: PropTypes.number,
    expiryDate: PropTypes.number,
    // productId: PropTypes.string,
    // itemType: PropTypes.string,
    quantity: PropTypes.number,
    part2Price: PropTypes.number,
  }),
};

export default EachCartItem;
